import { loadPdfBytes } from "./invoiceSource";
import { extractTextFromPdfBytes } from "./pdfText";
import { parseInvoiceText } from "./parseInvoice";
import type { InvoiceImportSource, ParsedInvoiceDraft } from "./types";

const PARSE_TIMEOUT_MS = 120_000;

function withTimeout<T>(promise: Promise<T>, message: string): Promise<T> {
  return Promise.race([
    promise,
    new Promise<T>((_, reject) => {
      window.setTimeout(() => reject(new Error(message)), PARSE_TIMEOUT_MS);
    }),
  ]);
}

/** Parse any invoice source (catalog URL or uploaded bytes) into a normalized draft. */
export async function parseInvoiceFromSource(
  source: InvoiceImportSource,
  uploadBytes?: ArrayBuffer,
): Promise<ParsedInvoiceDraft> {
  const bytes = await loadPdfBytes(source, uploadBytes);
  const text = await withTimeout(
    extractTextFromPdfBytes(bytes),
    "PDF parsing timed out. The file may be too large, or the PDF worker failed to start. Refresh and try again.",
  );

  if (!text.trim()) {
    throw new Error("No text could be extracted from this PDF.");
  }

  return parseInvoiceText(source.filename, text);
}
